import { gql } from "@apollo/client";

export const CREATE_LIVE_STOCK = gql`
  mutation CreateLiveStock($data: LiveStockInput!) {
    createLiveStock(data: $data) {
        id
    }
}
`;

export const CREATE_LIVE_STOCK_V2 = gql`
  mutation CreateLiveStockV2($data: LiveStockInput!) {
    createLiveStockV2(data: $data) {
      id
    }
  }
`;

export const CLEAR_CACHE_LIVE_STOCK_REDIS = gql`
  mutation ClearCacheLiveStockRedis($liveId: ID!) {
    clearCacheLiveStockRedis(liveId: $liveId)
  }
`;

export const CREATE_MANY_LIVE_STOCKS = gql`
mutation CreateManyLiveStock($data: [LiveStockInput]!) {
  createManyLiveStock(data: $data) {
    id
  }
}
`;

export const UPDATE_LIVE_STOCK = gql`
  mutation UpdateLiveStock($data: LiveStockInput!,$where: LiveStockWhereInputOne!) {
    updateLiveStock(where: $where, data:$data) {
        id
    }
}
`;

export const UPDATE_BULK_WRITE_LIVE_STOCK = gql`
  mutation UpdateBulkWriteLiveStock($data: [LiveStockInput]!) {
    updateBulkWriteLiveStock(data: $data) {
      status
      msg
      tag
      err
    }
  }
`;

export const DELETE_LIVE_STOCK = gql`
  mutation DeleteLiveStock($where: LiveStockWhereInputOne!) {
    deleteLiveStock(where: $where) {
        id
    }
}
`;

export const CREATE_STOCK_AND_PRODUCT = gql`
  mutation CreateStockAndProduct($data: StockAndProductInput!) {
    createStockAndProduct(data: $data) {
      message
    }
  }
`;
export const CREATE_STOCK_AND_PRODUCTS = gql`
  mutation CreateStockAndProducts($data: StockAndProductsInput!) {
  createStockAndProducts(data: $data) {
    message
  }
}
`;